<template>
  <el-container>
    <el-main>
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
        <el-row>
          <el-col :span="4" class="cls-col">
            <el-form-item label="博客类别" prop="categoryId" >
              <el-select v-model="searchData.categoryId" clearable placeholder="博客类别" size="small" style="width: 100%">
                <el-option
                    v-for="item in categoryData"
                    :key="item.categoryName"
                    :label="item.categoryName"
                    :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态" prop="status" class="cls-col">
              <el-select v-model="searchData.status" clearable placeholder="状态" size="small" style="width: 100%">
                <el-option label="置顶+最新" :value="1"></el-option>
                <el-option label="置顶" :value="2"></el-option>
                <el-option label="最新" :value="3"></el-option>
                <el-option label="普通" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标题" prop="title" class="cls-col">
              <el-input v-model="searchData.title" placeholder="内容" size="small" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
        </el-form-item>
      
      </el-form>
      <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="addBlogs" class="but-cls">
        添加博客
      </el-button>
      <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteBlogsMore" class="but-cls">删除博客
      </el-button>
      <el-table
          :data="commodityData"
          border
          @selection-change="handleSelectionChange"
          highlight-current-row
          style="width: 100%">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            type="index"
            label="序号"
            width="50"
            fixed="left"
        >
        </el-table-column>
        <el-table-column
            prop="title"
            fixed
            label="博客标题"
            width="150"
        >
        </el-table-column>
        <el-table-column
            prop="titleEn"
            label="博客英文标题"
        >
        </el-table-column>
        <el-table-column
            prop="categoryName"
            label="所属类别"
        >
        </el-table-column>
        <el-table-column
            prop="keyWord"
            label="关键字"
        >
        </el-table-column>
        <el-table-column
            prop="author"
            label="作者"
        >
        </el-table-column>
        <el-table-column
            prop="status"
            :formatter="f_status"
            label="状态"
        >
        </el-table-column>
        <el-table-column
            prop="isSendEmail"
            :formatter="f_isSendEmail"
            label="是否发送订阅"
        >
        </el-table-column>
        <el-table-column
            prop="clicks"
            label="点击量"
            width="65"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="创建时间"
            :formatter="dateFormat"
            width="170"
        >
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="300"
        >
          <template slot-scope="scope" style="height:fit-content">
            <el-button type="text" size="small" @click="updateBlogs(scope.row)">编辑</el-button>
            <el-button @click="deleteBlogs(scope.$index, scope.row)" type="text" size="small">删除</el-button>
            <el-button @click="showNews(scope.row)" type="text" size="small">预览</el-button>
            <el-button  :disabled="scope.row.isSendEmail == 1" @click="sendBlogSubscribeEmail(scope.row)" type="text" size="small">发送订阅</el-button>
            <el-badge  :value="scope.row.unReviewCommentNum" :hidden="scope.row.unReviewCommentNum == 0" :max="99" class="item">
                <el-button @click="reviewStatus(scope.row)" type="text" size="small">评论审核</el-button>
            </el-badge>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import {dateFormat, monthFormat} from '@/api/utils.js';

  const formData = {};
  export default {
    data() {
      return {
        formData: JSON.parse(JSON.stringify(formData)),
        commodityData: [],
        href: '',
        searchData: {
          size: 0,
          page: 1,
          title: '',
          categoryId: '',
          ccId2: '',
          ccId: '',
          status: '',
          isSendEmail:'',
          id:'',
          orgCode: ''
        },
        categoryData: [],
        commoditys: [],
        ccId2Data: [],
        organizationData: [],
        showEdit: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        multipleSelection: [],
        courseOptions: [],
        
      };
    },
    methods: {
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      f_status(row, column, cellValue, index) {
        if (cellValue == '1') {
          return '置顶+最新';
        }
        else if (cellValue == '2') {
          return '置顶';
        }
        else if (cellValue == '3') {
          return '最新';
        }
        else if (cellValue == '4') {
          return '普通';
        }
        return '';
      },
      f_isSendEmail(row, column, cellValue, index) {
        if (cellValue == '0' || cellValue == null) {
          return '未发送';
        }
        else if (cellValue == '1') {
          return '已发送';
        }
        return '';
      },
      handleEdit(index, row) {
        this.showEdit[row.commodityId] = true;
        this.search();
      },
      addBlogs() {
        this.$router.push({
          name: 'addblog',
          params: {'title': '添加博客'}
        });
      },
      dateFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (let index in val) {
          this.multipleSelection[index] = val[index].id;
        }
      },
      updateBlogs(row) {
        this.$router.push({
          name: 'addblog',
          params: row
        });
      },
      reviewStatus(row) {
        this.$router.push({
          name: 'blogcommentlist',
          params: row
        });
      },
      showNews(row) {
        let params = {
          blogId: row.id
        };
        https.fetchPost(https.blogURL + '?blogId=' + row.id, params, 'json').then((data) => {
           var url = data.data.split("*")[1];
           window.open(url, '_blank');
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
      },
      deleteBlogsMore() {
        let length = this.multipleSelection.length;
        this.$confirm('此操作将删除' + length + '条博客, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let multipleSelection = this.multipleSelection;
          let params = {'blogIdList': multipleSelection};
          https.fetchPost('/webBlog/deleteBlog', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteBlogs(index, row) {
        //deleteIsRecommendByCommodityId
        this.$confirm('此操作将删除该博客, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {'blogIdList': []};
          params.blogIdList.push(row.id);
          https.fetchPost('/webBlog/deleteBlog', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败：' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
     sendBlogSubscribeEmail(row) {

        let params = {
            'id': row.id
        };
        console.log("row.id:",params);
        https.fetchPost('/webBlog/sendBlogSubscribeEmail', params, 'json').then((data) => {
           console.log("row.data:",data);
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
              this.$message({
                type: 'success',
                message: '发送成功!'
              });
              this.search();
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },
      monthFormat(row, column, cellValue, index) {
        if (cellValue != null) {
          return monthFormat(cellValue);
        } else {
          return cellValue;
        }
      },
      search(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = 10;
        let params = this.searchData;
        https.fetchPost('/webBlog/list', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            console.log("data:",data);
            this.commodityData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },
      loadBlogCategory() {
        this.categoryData = [];
        if(!this.searchData.orgCode) {
          return;
        }
        let params = {
          orgCode: this.searchData.orgCode
        };
        https.fetchPost('/webBlogCategory/getCategoryDropDownList', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            if(data.data.data) {
              this.categoryData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      searchCourseType() {
        this.commoditys = [];
        if(!this.searchData.orgCode) {
          return;
        }
        let params = {
          orgCode: this.searchData.orgCode
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if(data.data.data) {
              for(let commodity of data.data.data) {
                if(commodity.children) {
                  for(let child of commodity.children) {
                    if(child.children) {
                      child.children = null;
                    }
                  }
                  this.commoditys.push(commodity);
                }
              }
            }

          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      changeOrg() {
        this.searchCourseType();
        this.searchData.ccId = '';
        this.loadBlogCategory();
        this.searchData.categoryId = "";
      },

      loadOrganization() {
        let params = {};
        https.fetchGet('/managerOrganization/getOrganizationList', params, 'from').then((data) => {
          let code = data.data.code;
          if (code == 200) {
            let d = data.data.data;
            if(data.data.data) {
              this.organizationData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      changeCourse(val) {
        //this.searchData.categoryId = '';
      }
    },
    created: function() {
      this.searchData.orgCode = this.$store.state.orgCode;
      this.searchCourseType();
      this.loadBlogCategory();
      this.loadOrganization();
      this.search();
    }
  };
</script>

<style scoped>
  .but-cls {
    margin-bottom: 10px;
  }
  
  .line {
    text-align: center;
  }
  
  .edit-cell {
    width: 60%;
  }
  
  .cls-col {
    margin-right: 20px;
  }
  
  .target {
    margin-left: 10px;
    color: #409EFF;
  }
  .item {
    margin-left: 10px;
  }
</style>
<style lang="less">
.item {
   .el-badge__content.is-fixed {
   top: 9px;
   right: 6px;

  }
}
</style>